import Hotkeys from 'react-hot-keys'
import type { DocumentFragment } from '~app/graph/generated/graphql'
import DocumentDialog from '../../components/DocumentDialog'

interface Props {
  documents: DocumentFragment[]
  selectedDocument: DocumentFragment
  onClose: () => Promise<void>
  onRemoveDocumentDone: () => void
  onSelectDocument: (id: string) => void
}

const DocumentNavigator = ({
  documents,
  selectedDocument,
  onClose,
  onRemoveDocumentDone,
  onSelectDocument,
}: Props) => (
  <Hotkeys
    keyName="shift+a,shift+d"
    onKeyDown={keyName => {
      try {
        const currentIndex = documents.indexOf(selectedDocument)

        if (keyName === 'shift+a') {
          const previousIndex = (currentIndex - 1) % documents.length
          onSelectDocument(documents[previousIndex].id)
        } else {
          const nextIndex = currentIndex + 1
          onSelectDocument(documents[nextIndex].id)
        }
      } catch (_e) {
        return
      }
    }}
  >
    <DocumentDialog
      key={selectedDocument.id}
      document={selectedDocument}
      onClose={onClose}
      onRemoveDocumentDone={onRemoveDocumentDone}
    />
  </Hotkeys>
)

export default DocumentNavigator
